//パスの指定
export const API_PATH = {
  ENQUETE_CREATE: '/general/enquete-create',
  ENQUETE_ANSWER: '/general/enquete-answer',
  ENQUETE_REQUEST: '/general/enquete-request',
  ENQUETE_CONFIRM: '/general/enquete-confirm',
  ENQUETE_STATUS: '/general/enquete-status',
  ENQUETE_CALENDAR: '/general/enquete-calendar',
};
